export default function customerDirective() {
  return {
    template: require('./customer.html'),
    scope: {
      user: '=',
      customer: '=',
    },
    controller: 'UACustomerController',
    controllerAs: 'customerVM',
    bindToController: true,
    replace: true,
  };
}
